<template>
  <div>
    <h4>Terms Of Service</h4>
    <hr>
    <terms />
  </div>
</template>

<script>
    import Terms from "@/components/Guest/Terms.vue";

    export default {
        components: {
            Terms
        }
    }
</script>
